<template>
  <el-dialog
    title="劵码管理"
    :visible.sync="visible"
    width="700px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form"> </div>
    <el-form label-width="90px">
      <el-form-item
        key="couponName"
        label="优惠劵名称:"
        prop="couponName">
        {{ config.couponName }}
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="劵码"
        width="160"
        prop="couponNumber"></el-table-column>
      <el-table-column
        label="状态"
        width="90">
        <template slot-scope="{row}">
          <el-tag
            v-if="row.status === 1"
            type="info">未领取</el-tag>
          <el-tag v-if="row.status === 2">已领取</el-tag>
          <el-tag
            v-if="row.status === 3"
            type="success">已使用</el-tag>
          <el-tag
            v-if="row.status === 8"
            type="warning">已过期</el-tag>
          <el-tag
            v-if="row.status === 9"
            type="danger">已作废</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="时间"
        width="140">
        <template slot-scope="{row}">
          <div v-if="row.status === 3">
            使用时间{{ row.usedTime | dateformat() }}
          </div>
          <div v-if="row.status === 2">
            领取时间{{ row.receivedTime | dateformat() }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="关联订单"
        prop="orderId"></el-table-column>
      <el-table-column
        label="用户昵称"
        prop="userName"></el-table-column>
      <el-table-column
        label="操作"
        width="100">
        <template slot-scope="{row}">
          <el-button
            v-if="row.status === 1"
            type="text"
            style="margin-left:10px"
            @click="invalidcouponnumber(row)">强制过期</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CouponNumModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        couponId: null,
        couponName: null,
        vendorId: null,
        pageNum: 1,
        pageSize: 10
      },
      totalNum: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.totalNum = 0
      this.config.couponId = null
      this.config.couponName = null
      this.config.vendorId = null
      this.config.pageNum = 1
    },
    invalidcouponnumber(row) {
      this.$confirm('您确定强制过期该券码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('coupon/invalidcouponnumber', {
            payload: {
              vendorId: row.vendorId,
              couponNumber: row.couponNumber
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('coupon/getcouponnumbers', {
        payload: {
          ...this.config
        },
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.couponId = row.couponId
      this.config.couponName = row.couponName
      this.config.vendorId = row.vendorId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
